import {combineReducers} from 'redux'
import folder from './ftpFolderReducer'
import spinner from './SpinnerReducer'
export default combineReducers({
    folder, spinner
})